<template>
  <sui-page>
    <sui-page-header
      :title="pageTitle"
      :location-list="pageLocations"
      :is-show="isPageHeaderShow"
      :is-favorites="isMyFavorites"
    />
    <sui-page-contents>
      <div class="comm_btn_wrap">
        <div class="col-xs-5">
          <sui-code-select
            ref="codeSelectSearchCondition"
            codeId="COD_DSBD_SEARCH_COND"
            :defaultOption="'all'"
            @list-clicked="onChangeOption"
          />
        </div>
      </div>
      <!-- Bar Chart-[S] -->
      <sui-chart-bar
        ref="chartBar"
        v-if="chartData[0] !== null"
        :styles="{display: 'block'}"
        :width="800"
        :height="400"
        :chart-data="chartData[0]"
        :options="chartOptions"
        @barchartClicked="barchartClicked"
      />
      <!-- Bar Chart-[E] -->
    </sui-page-contents>
  </sui-page>
</template>

<script>
// 차트 라벨
const chartLabels = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export default {
  name: 'CompBarChart',
  data() {
    return {
      // Bar Chart 옵션
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: { display: true, text: 'Vertical' },
        // tooltips: {
        //   callbacks: {
        //       label: function(tooltipItem, chart) {
        //         console.log(tooltipItem.value, tooltipItem.label )
        //         /* tooltipItem
        //         datasetIndex: 1
        //         index: 7
        //         label: "August"
        //         value: "80"
        //         x: 980.2818359374999
        //         xLabel: "August"
        //         y: 66.39999999999998
        //         yLabel: 80
        //         */
        //         return chart.datasets[tooltipItem.datasetIndex].label +': '+ tooltipItem.value;
        //       }
        //   },
        // },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: 'probability',
            },
          }],
        },
      },
      chartOptions1: {
        responsive: false,
        title: { display: true, text: 'Vertical' },

        scales: {
          yAxes: [{
            // ticks: {
            //   callback: function(value, index, values) {
            //     return value/10;
            //   }
            // },
            // /*
            scaleLabel: {
              display: true,
              labelString: 'probability',
            },
            // */
          }],
        },
      },

      // Bar Chart 데이터
      chartData: [null, null, null, null, null, null],

      // 페이지 헤더
      pageTitle: 'Bar Chart UI',
      pageLocations: ['Charts', 'Bar', 'Guide'],
      isPageHeaderShow: true,
      isMyFavorites: true,
    };
  },
  mounted() {
    this.fillChartData();
  },
  methods: {
    barchartClicked(element) {
      console.log(element);
    },
    onChangeOption() {
      const slectKey = this.$refs.codeSelectSearchCondition.selected.key;
      let unit = 1;
      this.chartOptions.title.text = 'Title Change  '+slectKey;
      this.chartOptions.scales.yAxes[0].scaleLabel.labelString = this.$refs.codeSelectSearchCondition.selected.key;
      // this.$refs.chartBar.updateChart();
      // this.$refs.chartBar.renderChart(this.chartData[0], this.chartOptions1);
      if (slectKey === 'NM') {
        unit = 100;
      } else if (slectKey === 'ID') {
        unit = 10;
      }
      const chartDataMake = {
        labels: chartLabels,
        datasets: [
          {
            label: '행복지수',
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
            data: [40/unit, -20/unit, 12/unit, 39/unit, 15/unit, 40/unit, -39/unit, 80/unit, 40/unit, -20/unit, 12/unit, 11/unit],
          },
          {
            label: '불쾌지수',
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
            data: [40/unit, 80/unit, 12/unit, 39/unit, 15/unit, 40/unit, 66/unit, 80/unit, 40/unit, -20/unit, 12/unit, 11/unit],
          },
        ],
      };


      // Set
      this.$set(this.chartData, 0, _.cloneDeep(chartDataMake));
      this.chartData[0].datasets.push({
        label: '우울지수',
        backgroundColor: 'rgba(120, 3, 295, 0.8)',
        data: [80/unit, 20/unit, -20/unit, 60/unit, 30/unit, 70/unit, 69/unit, 30/unit, 30/unit, 41/unit, -12/unit, 31/unit],
      });
      this.$refs.chartBar.updateChart();
    },
    onErrorFillChartData(error) {
      console.log('CompBarChart.onErrorFillChartData() was called.');
      console.log(error);
    },
    setChartOptions() {
      // [Sample] 예를 들어. 데이터 모양(서버 response 데이타)이 아래와 같다 가정.
      // data = [
      //   {
      //     label: '행복지수',
      //     data: [40, -20, 12, 39, 15, 40, -39, 80, 40, -20, 12, 11],
      //   },
      //   {
      //     label: '불쾌지수',
      //     data: [40, -20, 12, 39, 15, 40, -39, 80, 40, -20, 12, 11],
      //   },
      // ];

      // Data
      const chartOptions = {
        labels: chartLabels,
        datasets: [
          {
            label: '행복지수',
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
            data: [40, -20, 12, 39, 15, 40, -39, 80, 40, -20, 12, 11],
          },
          {
            label: '불쾌지수',
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
            data: [40, 80, 12, 39, 15, 40, 66, 80, 40, -20, 12, 11],
          },
        ],
      };

      // Set
      this.$set(this.chartData, 0, _.cloneDeep(chartOptions));
    },
    fillChartData() {
      // [Sample] 서버로부터 차트 데이터 호출 시,
      // http
      //   .request("pageId", "dataServiceId", {})
      //   .then(this.setChartOptions)
      //   .catch(this.onErrorFillChartData);

      this.setChartOptions();

      // [Sample] 이미 있는 차트 데이터셋에, 스크립트로 데이터셋 추가할 때,
      this.chartData[0].datasets.push({
        label: '미소지수',
        backgroundColor: 'rgba(120, 3, 255, 0.8)',
        data: [70, 10, -30, 50, 20, 60, 59, 20, 20, 40, -22, 21],
      });
    },
  },
};
</script>
